function checkRequired() {
      var okayOrNot = true;    
  
      $('.required').each(function() {
        //if(this.selectedIndex == 0) {
        if($(this).val() == undefined || $(this).val() == "") {
          okayOrNot = false;
          $(this).addClass("inv-error");
        }else{
          $(this).removeClass("inv-error");
        }
      });
      
     return okayOrNot;
}

function checkRequiredFields(contentId) {
      var okayOrNot = true;        
      $('#'+ contentId + ' .required').each(function() {
        //if(this.selectedIndex == 0) {
        if($(this).val() == undefined || $(this).val() == "") {
          okayOrNot = false;
          $(this).addClass("inv-error");
        }else{
          $(this).removeClass("inv-error");
        }
      });
      
     return okayOrNot;
}

 function IsEmail() {
   var regex = /^[a-zA-Z0-9_\+-]+(\.[a-zA-Z0-9_\+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.([a-zA-Z]{2,4})+$/;
   var email = $(".email").val();
   if(email != ""){
    if (!regex.test(email.trim())) {
        $(".email").addClass("inv-error");
       return false;
     } else {
       $(".email").removeClass("inv-error");
       return true;
     }
   }
   return true;
 }

 function IsEmailFields(contentId) {
   var regex = /^[a-zA-Z0-9_\+-]+(\.[a-zA-Z0-9_\+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.([a-zA-Z]{2,4})+$/;
   var email = $("#"+ contentId + " .email").val();
   if(email != ""){
     if (!regex.test(email.trim())) {
        $(".email").addClass("inv-error");
       return false;
     } else {
       $(".email").removeClass("inv-error");
       return true;
     }
   }
   return true;
 }

function IsPhoneNumber() {
  var regex = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
  var phoneNumber = $(".phoneNumber").val();
  if(phoneNumber != ""){
    if (!regex.test(phoneNumber)) {
      $(".phoneNumber").addClass("inv-error");
      return false;
    } else {
      $(".phoneNumber").removeClass("inv-error");
      return true;
    }
  }
  return true;
}

function IsPhoneNumber(contentId) {
  var regex = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
  var phoneNumber = (contentId == undefined || contentId == null )? $(".phoneNumber").val() : $("#"+ contentId + " .phoneNumber").val();
  if(phoneNumber != ""){
    if (!regex.test(phoneNumber)) {
      $(".phoneNumber").addClass("inv-error");
      return false;
    } else {
      $(".phoneNumber").removeClass("inv-error");
      return true;
    }
  }
  return true;
}


/*

$(document).ready(function () {   
  $('.required').on('change', function (){ 
    if($(this).val() != ""){
    	$(this).removeClass("inv-error");
    }
  });
  
  $('.required').on('blur', function (){
    if($(this).val() != ""){
    	$(this).removeClass("inv-error");
    }
  });
  
});

*/